import { z } from "zod";
import { getBaseFilterOutput } from "@/Schemas/BaseFilterOutput";
import { RequestListingDataSchema, RequestListingData } from "@/Schemas/Listing/RequestListingData";

export const ListingOutputSchema = getBaseFilterOutput<RequestListingData>(RequestListingDataSchema);

export type ListingOutput = z.infer<typeof ListingOutputSchema>;